PES = PES || {};
PES.Gallery = function () {
    var init = function (path) {
        $('.img-container img').slickhover({
            icon: path,
            color: "#52b161",
            opacity: 0.4,
            speed: 400,
            animateIn: false,
            text: "View timeline"
        });

        $('.gallery-images').magnificPopup({
            delegate: '.image',
            type: 'image',
            closeOnContentClick: false,
            mainClass: 'mfp-with-zoom mfp-img-mobile',
            image: {
                titleSrc: function (item) {
                    var $title = $(item.el).closest(".img-container").find(".img-title");
                    var html = $title.find(".hidden").html();

                    return html;
                }
            },
            gallery: {
                enabled: true
            },
            zoom: {
                enabled: true,
                duration: 300, // don't foget to change the duration also in CSS
                opener: function (element) {
                    return element.find('img');
                }
            }

        });
        let gallery_slider = tns({
            "container": ".gallery",
            "items": 1,
            "navContainer": ".thumbs",
            "controlsContainer": ".gallery__controls",
            "mouseDrag": true,
            "touch": true,
            // "lazyload": true,
            "autoplayButtonOutput": false,
            "speed": 400,
            // "loop": true,
            "rewind": true,
            // "autoHeight": true
        });

        let thumbnail_slider = tns({
            "container": ".thumbs",
            "mouseDrag": true,
            "touch": true,
            "controls": false,
            "nav": false,
            // "lazyload": true,
            "autoplayButtonOutput": false,
            "items": 1,
            "edgePadding": 50,
            "fixedWidth": 112,
            "center": true,
            "loop": false,
            "swipeAngle": false,
            "rewind": true,

            responsive: {
                769: {
                    "fixedWidth": 192,
                }
            }
            // "gutter": 20
        });

        let updateGallery = function (info, eventName) {
            let currentIndex = info.displayIndex;
            thumbnail_slider.goTo(currentIndex - 1);

        }

        gallery_slider.events.on('transitionStart', updateGallery);

        let imageFinalHeight = 100;

        $(".sample").click(function () {
            var index = $(".sample").index(this);
            $('#tns2-item' + index)[0].click();
            $('.js-open-gallery')[0].click();
        });
    }

    return {
        init: init
    }
}